import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=20d85844&scoped=true"
import script from "./Checkout.vue?vue&type=script&lang=js"
export * from "./Checkout.vue?vue&type=script&lang=js"
import style0 from "./Checkout.vue?vue&type=style&index=0&id=20d85844&prod&lang=scss&scoped=true"
import style1 from "./Checkout.vue?vue&type=style&index=1&id=20d85844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d85844",
  null
  
)

export default component.exports